import { render, staticRenderFns } from "./publicvenue.vue?vue&type=template&id=3c7a0ea8&scoped=true"
import script from "./publicvenue.vue?vue&type=script&lang=js"
export * from "./publicvenue.vue?vue&type=script&lang=js"
import style0 from "./publicvenue.vue?vue&type=style&index=0&id=3c7a0ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a0ea8",
  null
  
)

export default component.exports